import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "sidebar-box"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "flex-1 text-xs"
};
const _hoisted_4 = {
  class: "text-xs"
};
const _hoisted_5 = {
  class: "text-ob pr-2"
};
const _hoisted_6 = {
  key: 0,
  class: "text-ob-secondary bg-ob-deep-800 py-0.5 px-1.5 rounded-md opacity-75"
};
const _hoisted_7 = {
  class: "text-gray-500"
};
const _hoisted_8 = {
  class: "text-xs text-ob-bright"
};
const _hoisted_9 = {
  class: "flex-1 text-xs"
};
const _hoisted_10 = {
  class: "text-xs"
};
const _hoisted_11 = {
  class: "text-ob pr-2"
};
const _hoisted_12 = {
  class: "text-xs text-ob-bright"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SubTitle = _resolveComponent("SubTitle");
  const _component_ob_skeleton = _resolveComponent("ob-skeleton");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_SubTitle, {
    title: 'titles.recent_comment',
    icon: "quote"
  }), _createElementVNode("ul", null, [_ctx.comments.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.comments, comment => {
    return _openBlock(), _createElementBlock("li", {
      class: "bg-ob-deep-900 px-2 py-3 mb-1.5 rounded-lg flex flex-row justify-items-center items-center shadow-sm hover:shadow-ob transition-shadow",
      key: comment.id
    }, [_createElementVNode("img", {
      class: "col-span-1 mr-2 rounded-full p-1",
      src: comment.user.avatar_url,
      alt: "comment-avatar",
      height: "40",
      width: "40"
    }, null, 8 /* PROPS */, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, [_createTextVNode(_toDisplayString(comment.user.login) + " ", 1 /* TEXT */), comment.is_admin ? (_openBlock(), _createElementBlock("b", _hoisted_6, _toDisplayString(_ctx.t('settings.admin-user')), 1 /* TEXT */)) : _createCommentVNode("v-if", true)]), _createElementVNode("p", _hoisted_7, _toDisplayString(comment.created_at), 1 /* TEXT */)]), _createElementVNode("div", _hoisted_8, _toDisplayString(comment.body), 1 /* TEXT */)])]);
  }), 128 /* KEYED_FRAGMENT */)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, _renderList(7, n => {
    return _createElementVNode("li", {
      class: "bg-ob-deep-900 px-2 py-3 mb-1.5 rounded-lg flex flex-row justify-items-center items-center shadow-sm hover:shadow-ob transition-shadow",
      key: n
    }, [_createVNode(_component_ob_skeleton, {
      class: "col-span-1 mr-2 rounded-full p-1",
      height: "40px",
      width: "40px",
      circle: true
    }), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, [_createVNode(_component_ob_skeleton, {
      tag: "b",
      class: "text-ob-secondary bg-ob-deep-800 py-0.5 px-1.5 rounded-md",
      height: "10px",
      width: "66px"
    })]), _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1 /* HOISTED */)), _createVNode(_component_ob_skeleton, {
      tag: "p",
      class: "text-ob-secondary bg-ob-deep-800 py-0.5 px-1.5 rounded-md",
      height: "10px",
      width: "96px"
    })]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_ob_skeleton, {
      class: "text-ob-secondary bg-ob-deep-800 py-0.5 px-1.5 rounded-md",
      height: "10px",
      width: "126px"
    })])])]);
  }), 64 /* STABLE_FRAGMENT */))])]);
}